// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"72d24139ccd1c786","517":"94a5baacdb4b1378","888":"72d24139ccd1c786"}[chunkId] + ".css";
};